import { AlertCircle } from 'lucide-react';

interface ToolReadinessErrorProps {
  toolName?: string;
  onRetry?: () => void;
}

/**
 * Shared error state when tool readiness check fails (backend unavailable, network error, etc.)
 */
export function ToolReadinessError({ toolName = 'Tool', onRetry }: ToolReadinessErrorProps) {
  return (
    <div className="max-w-4xl mx-auto px-6 py-12">
      <div className="bg-red-50 border border-red-200 rounded-lg p-8">
        <div className="flex items-start gap-4">
          <AlertCircle className="w-6 h-6 text-red-600 flex-shrink-0 mt-1" />
          <div className="flex-1">
            <h3 className="text-lg font-semibold text-red-900 mb-2">
              Unable to Load {toolName}
            </h3>
            <p className="text-red-800 mb-4">
              Failed to check tool prerequisites. This could be due to a network issue or the backend service being temporarily unavailable.
            </p>
            <button
              onClick={onRetry || (() => window.location.reload())}
              className="px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-md transition-colors font-medium"
            >
              Retry
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
